import { LoanRequest_ApplicantCreditRatingReceived } from 'cpool-events';
// import type { EventSchema } from 'cpool-events';
import { schemaId } from 'cpool-schemas';
import { z } from 'zod';

// export type ConsorsSchufaInfoTableSchema = {
//     applicantId: string;
//     data: {
//         ratedAt: Date;
//     } & Omit<EventSchema<LoanRequest_ApplicantCreditRatingReceived>, 'applicantId'>;
//     loanRequestId: string;
//     ratedAt: Date;
// };

export const ConsorsSchufaInfoTableDefinitionZod = LoanRequest_ApplicantCreditRatingReceived.prototype
    .getSchema()
    .merge(
        z.object({
            applicantId: schemaId,
            loanRequestId: schemaId,
            ratedAt: z.coerce.date(),
        }),
    );

export type ConsorsSchufaInfoTableSchema = z.infer<typeof ConsorsSchufaInfoTableDefinitionZod>;
